import {auth, db, firebaseApp} from "../firebase";
import {RoleEnum} from "../db/models/role";
import {Collections} from "./collections";
import firebase from "firebase/compat/app";
import {StudentInterface} from "../db/models/student/student";
import {resetStore} from "../helpers/misc";
import "firebase/compat/functions";
import {CredentialsI} from "../db/models/auth/auth";
import {getUserByEmail} from "../api/user";

export const getUid = () => {
    return auth.currentUser ? auth.currentUser.uid : null;
};

export const LoginWithEmailAndPassword = (email: string, password: string) => {
    return auth.signInWithEmailAndPassword(email, password);
};

export const checkIfEmailNotInUse = (email) => {
    if (!email) return Promise.resolve(true);

    return auth
        .fetchSignInMethodsForEmail(email)
        .then((methods) => {
            return methods.length === 0;
        })
        .catch((error) => true);
};

// export const LoginWithGoogle = (navigate) => {
// 	var provider = new firebase.auth.GoogleAuthProvider();
// 	return auth
// 		.signInWithPopup(provider)
// 		.then((userCredential) => {
// 			if (userCredential.additionalUserInfo.isNewUser) {
// 				const user = userCredential.user;
// 				const uid = user.uid;
// 				const data = {
// 					uid: uid,
// 					name: user.displayName,
// 					photoURL: user.photoURL,
// 					email: user.email,
// 				};
// 				// return onUserSignup(uid, data, 'student', navigate);
// 			} else {
// 				return Promise.resolve();
// 			}
// 		})
// 		.catch(function (error) {
// 			return Promise.reject(error);
// 		});
// };

export const NewRegisterWithEmailAndPassword = async ({
                                                          email,
                                                          password,
                                                          otherStudentInfo = {},
                                                          dispatch,
                                                      }: {
    email: string;
    password: string;
    otherStudentInfo?: Partial<StudentInterface>;
    dispatch: any;
}): Promise<any> => {
    let uid: string | null;
    let userCredential;
    try {
        const oldUser = await getUserByEmail(email);
        if(oldUser) throw new Error("user already in db");

        // sign the student up
        userCredential = await auth.createUserWithEmailAndPassword(email, password);
        uid = userCredential.user?.uid || null;

        if (!uid) throw new Error("missing userCredential.user.uid");
    } catch (error) {
        console.error(error);
        Logout(dispatch);
        return Promise.reject(error);
    }

    console.log(userCredential);

    let keepTrying = true;
    let tryCount = 0;

    do {
        try {
            tryCount++;
            //set user doc for future updates
            const user = {
                id: uid,
                created: firebase.firestore.FieldValue.serverTimestamp(),
                role: "student",
                email,
                privacyLastSignedAt: firebase.firestore.FieldValue.serverTimestamp(),
                ...otherStudentInfo,
            };
            console.log(user);
            await db.collection(Collections.USERS).doc(uid).set(user);

            keepTrying = false;
        } catch {
            keepTrying = true;
        }
    } while (keepTrying && tryCount < 10);

    console.log(tryCount);

    // send email verification
    try {
        await auth.currentUser?.sendEmailVerification();
    } catch (error) {
    }

    return Promise.resolve();
};

export const signupAfolStudent = async (
    email: string,
    password: string,
    companyId: string
) => {
    const callable = firebaseApp
        .functions("europe-west1")
        .httpsCallable("signupAfolStudent");

    try {
        await callable({email, password, companyId});
        return LoginWithEmailAndPassword(email, password);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const Logout = async (dispatch) => {
    if (!dispatch) return Promise.reject();

    await auth.signOut();
    resetStore(dispatch);
    return;
};

export const updateUserEmail = (email: string, role: RoleEnum) => {
    const uid = getUid();
    if (!uid || !email || !role) throw new Error();

    return db.collection(Collections.USERS).doc(uid).update({email});
};

export const updateUserId = (uid: string) => {
    if (!uid) return Promise.reject();

    return db.collection(Collections.USERS).doc(uid).update({
        id: uid,
        uid: firebase.firestore.FieldValue.delete(),
    });
};

export const updateUserDisplayName = async (displayName: string) => {
    const currentUser = auth.currentUser;

    if (!currentUser || !displayName) return Promise.reject("missing params");

    try {
        await currentUser.updateProfile({displayName});
        await db
            .collection(Collections.USERS)
            .doc(currentUser.uid)
            .update({name: displayName});

        return Promise.resolve();
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getUserByUid = (uid: string) => {
    const callable = firebaseApp
        .functions("europe-west1")
        .httpsCallable("getUserByUid");

    return callable({uid});
};

// export const getUserByEmail = async (email: string) => {
//     if (!email) return Promise.resolve(null);
//
//     const callable = firebaseApp
//         .functions("europe-west1")
//         .httpsCallable("getUserByEmail");
//
//     const accountPromise = await callable({email});
//     if (accountPromise) return accountPromise.data;
//     else return null;
// };
